import App from "./Components/App";
import { AppContainer } from "react-hot-loader";
import * as React from "react";
import * as ReactDOM from "react-dom";
let isOfficeInitialized = false;

const title = "SFJ Lemon";
const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <Component title={title} isOfficeInitialized={isOfficeInitialized} />
    </AppContainer>,
    document.getElementById("container")
  );
};

/* Render application after Office initializes */
Office.onReady(() => {
  isOfficeInitialized = true;
  render(App);
});

if (module.hot) {
  module.hot.accept("./Components/App", () => {
    const NextApp = require("./Components/App").default;
    render(NextApp);
  });
}
